import React from 'react';
import { Grid } from '@mui/material';
import {
	BooleanInput,
	Create,
	SelectInput,
	SimpleForm,
	TextInput,
} from 'react-admin';

const featureTypeChoices = [
	{ id: 'boolean', name: 'Boolean' },
	{ id: 'quantity', name: 'Quantity' },
	{ id: 'enum', name: 'Enum' },
];

export const FeatureCreate = (props: any) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<TextInput source="slug" required />
						<TextInput source="name" required />
						<SelectInput source="type" choices={featureTypeChoices} required />
						<TextInput source="stripeProductId" label="Stripe Product ID" />
						<BooleanInput label="Enabled" source="enabled" defaultValue={true} />
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
